<div class="cads-heading-detail-bit" [class.cads-heading-detail-bit--small]="isSmall()">
  @if (effectiveConfig().eyebrow) {
    <span class="cads-heading-detail-bit__eyebrow">{{ effectiveConfig().eyebrow }}</span>
  }
  <div class="cads-heading-detail-bit__title-row">
    <span class="cads-heading-detail-bit__title">{{ effectiveConfig().title }}</span>
    @if (badgeBitConfig(); as badgeCfg) {
      <cads-badge-bit [config]="badgeCfg" />
    }
  </div>
  @if (effectiveConfig().subtitle) {
    <span class="cads-heading-detail-bit__subtitle">{{ effectiveConfig().subtitle }}</span>
  }
</div>
